import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

export const useMarkDiscussed = ({
  patientId,
  serviceRequestId,
}: {
  patientId: string;
  serviceRequestId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<void, void>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.MedicalRecords.Labs.MARK_DISCUSSED(
        patientId,
        serviceRequestId,
      ),
      mutationFn: () => {
        return axiosInstance.post(
          `/labs/triage/service-request/${serviceRequestId}/discussed`,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Labs.DEFAULT(patientId),
        });
      },
    },
  });
};
